import Vue from 'vue'

export const PinCodeMixin = Vue.extend({
  data: () => ({
    numOfInputs: 4,
    pinArray: [] as Array<string>,
    pinKey: 'pin'
  }),

  computed: {
    pin (): string {
      return this.pinArray.join('')
    },
    buttonEnabled (): boolean {
      return RegExp(/\d{4}/gi).test(this.pin)
    }
  },

  methods: {
    postParams (): URLSearchParams {
      const params = new URLSearchParams()
      params.append(this.pinKey, this.pin)
      return params
    },
    inputPin (e: KeyboardEvent): void {
      const currInput = e.target as HTMLInputElement
      // Accept only digits
      if (this.isDigitInput(e)) {
        // Id is set in the input's name
        const nextId = parseInt(currInput.name.slice(this.pinKey.length)) + 1
        if (nextId < this.numOfInputs && currInput.value.length > 0) {
          const el = this.$refs[this.pinKey + nextId] as Array<HTMLInputElement>
          // Select next input on next re-render
          this.$nextTick(() => el[0].focus())
        }
      } else {
        // Reset input field
        currInput.value = ''
      }
    },
    deletePin (e: KeyboardEvent): void {
      const keyPressed = e.code
      const currInput = e.target as HTMLInputElement
      // Deletion only available with these keys
      if (keyPressed === 'Backspace' || keyPressed === 'Delete' || e.key === 'Backspace') {
        const currId = parseInt(currInput.name.slice(this.pinKey.length))
        const prevId = currId - 1
        // Make sure to clear the current value from array
        this.pinArray[currId] = ''
        if (prevId >= 0) {
          const el = this.$refs[this.pinKey + prevId] as Array<HTMLInputElement>
          this.$nextTick(() => el[0].focus())
        }
      }
    },
    isNumpadDigit (keyPressed: string): boolean {
      if (!keyPressed.includes('Numpad')) {
        return false
      }
      // Return what comes after Numpad in string, e.g. Numpad1
      const digit = keyPressed.slice(6)
      return !isNaN(parseInt(digit))
    },
    isDigitInput (event: KeyboardEvent): boolean {
      const eventTarget = event.target as HTMLInputElement
      const eventData = {
        code: event.code,
        key: event.key,
        // This is needed because Samsung Internet browser doesn't emit above events correctly
        value: eventTarget.value.charAt(0)
      }

      return (eventData.code && (eventData.code.includes('Digit') || this.isNumpadDigit(eventData.code))) ||
        RegExp(/\d/).test(eventData.key) ||
        RegExp(/\d/).test(eventData.value)
    }
  }
})
